import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardComponent } from './dashboard.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { NgChartsModule } from 'ng2-charts';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { NgCircleProgressModule } from 'ng-circle-progress';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxEchartsModule } from 'ngx-echarts';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from 'src/app/app.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { NgxMaskPipe } from 'ngx-mask';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { AvailableBalanceCardComponent } from './available-balance-card/available-balance-card.component';
import { GeneralBalanceCardComponent } from './general-balance-card/general-balance-card.component';
import { TodaysSalesCardComponent } from './todays-sales-card/todays-sales-card.component';
import { AverageDailyTicketCardComponent } from './average-daily-ticket-card/average-daily-ticket-card.component';
import { SalesReceivedQuantityCardComponent } from './sales-received-quantity-card/sales-received-quantity-card.component';
import { ReceivedSalesCardComponent } from './received-sales-card/received-sales-card.component';
import { AverageSalesTicketCardComponent } from './average-sales-ticket-card/average-sales-ticket-card.component';
import { ReceiptConversionCardComponent } from './receipt-conversion-card/receipt-conversion-card.component';
import { WeeklySalesGraphComponent } from './weekly-sales-graph/weekly-sales-graph.component';
import { StatisticsSalesGraphComponent } from './statistics-sales-graph/statistics-sales-graph.component';
import { DashboardRoutingModule } from './dashboard-routing.module';

@NgModule({
  declarations: [
    DashboardComponent,
    AvailableBalanceCardComponent,
    GeneralBalanceCardComponent,
    TodaysSalesCardComponent,
    AverageDailyTicketCardComponent,
    SalesReceivedQuantityCardComponent,
    ReceivedSalesCardComponent,
    AverageSalesTicketCardComponent,
    ReceiptConversionCardComponent,
    WeeklySalesGraphComponent,
    StatisticsSalesGraphComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    NgChartsModule,
    NgbModule,
    NgApexchartsModule,
    NgCircleProgressModule.forRoot(),
    NgSelectModule,
    NgxEchartsModule.forRoot({
      echarts: () => import('echarts'),
    }),
    FormsModule,
    ReactiveFormsModule,
    NgxMaskPipe,
    ClipboardModule,
    DashboardRoutingModule,
  ],
  providers: [],
  exports: [],
  bootstrap: [AppComponent],
})
export class DashboardModule {}
